import {useEffect, useState} from 'react';

export default (props) => {
    const {hash, pathname, search} = props;
    const [isClient, updateIsClient] = useState(false);

    useEffect(() => {
        if (!isClient) {
            updateIsClient(true);
        }
    }, [isClient]);

    useEffect(() => {
        let top = 0;
        if (isClient) {
            if (hash) {
                const element = document.querySelector(hash);
                if (element) {
                    top = element.getBoundingClientRect().top;
                }
            }
            try {
                window.scroll({
                    top,
                    left: 0,
                });
            } catch (error) {
                window.scrollTo(top, 0);
            }
        }
    }, [pathname, search, hash, isClient]);

    return null;
};
